import styles from './FirebaseConfigErrorPage.module.css'

interface FirebaseConfigErrorPageProps {
  error: Error
}

export function FirebaseConfigErrorPage({ error }: FirebaseConfigErrorPageProps) {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.errorIcon}>⚙️</div>
        <h1 className={styles.title}>Configuration Error</h1>

        <div className={styles.message}>
          <p>
            <strong>Firebase is not configured.</strong>
          </p>
          <p>{error.message}</p>
        </div>

        <div className={styles.instructions}>
          <h2>To fix this:</h2>
          <ol>
            <li>Copy the file <code>.env.example</code> to <code>.env.local</code></li>
            <li>Fill in the Firebase configuration values from the Firebase Console</li>
            <li>Restart the development server</li>
          </ol>
        </div>

        <div className={styles.example}>
          <h3>Example <code>.env.local</code>:</h3>
          <pre>
            {`VITE_FIREBASE_API_KEY=your_api_key_here
VITE_FIREBASE_AUTH_DOMAIN=your_auth_domain_here
VITE_FIREBASE_PROJECT_ID=your_project_id_here
VITE_FIREBASE_STORAGE_BUCKET=your_storage_bucket_here
VITE_FIREBASE_MESSAGING_SENDER_ID=your_sender_id_here
VITE_FIREBASE_APP_ID=your_app_id_here`}
          </pre>
        </div>

        <div className={styles.support}>
          <p>
            Need help? Contact <a href="mailto:support@dataphyll.com">support@dataphyll.com</a>
          </p>
        </div>
      </div>
    </div>
  )
}
